// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import L from 'leaflet';

myw.BlankLayer = L.TileLayer.extend({
    /**
     * @class  Defines a blank layer. Sometimes used as a basemap
     * @constructs
     */
    initialize() {
        const url = '';
        L.TileLayer.prototype.initialize.call(this, url);
    }
});

export default myw.BlankLayer;
